"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEMO_WORKSPACE_INFO = void 0;
exports.DEMO_WORKSPACE_INFO = {
    dev1: {
        workspaceId: 'de75d2db-764b-4939-92fd-e3fb0523baa3',
    },
    dev2: {
        workspaceId: 'de75d2db-764b-4939-92fd-e3fb0523baa3',
    },
    qa: {
        workspaceId: 'de75d2db-764b-4939-92fd-e3fb0523baa3',
    },
    prod: {
        workspaceId: 'c361e3a0-a313-4585-9216-572bb200700d',
    },
};
//# sourceMappingURL=demo.js.map